import { faArrowsRotate, faQuestion } from '@fortawesome/free-solid-svg-icons';
import { CompanionRole } from '@konsolenkost-de/acquisition_store_server_sdk_vue';
import { type MaybeRef } from 'vue';
import { useBadgeInfoObject } from '../style/useBadgeInfoObject';
import { type DisplayBadgeType } from '../style/useDisplayBadgeClass';

export const useCompanionRoleInfo = (
  colorType: MaybeRef<DisplayBadgeType> = 'badge',
  role?: MaybeRef<CompanionRole>,
) => {
  const {
    badgeInfo,
    getBadgeClass,
    getBadgeColor,
    getBadgeIcon,
    getBadgeTitle,
    getBadgeInfo,
  } = useBadgeInfoObject<CompanionRole>(
    {
      i18nPrefix: 'companion.roles',
      colorMap: {
        [CompanionRole.FILE_SYNC]: 'primary',
      },
      iconMap: {
        [CompanionRole.FILE_SYNC]: faArrowsRotate,
      },
      defaultColor: 'neutral',
      defaultIcon: faQuestion,
    },
    colorType,
    role,
  );

  return {
    companionRoleInfo: badgeInfo,
    getCompanionRoleTitle: getBadgeTitle,
    getCompanionRoleDescription: (roleValue: CompanionRole) =>
      getBadgeTitle(roleValue, 'description'),
    getCompanionRoleClass: getBadgeClass,
    getCompanionRoleColor: getBadgeColor,
    getCompanionRoleIcon: getBadgeIcon,
    getCompanionRoleInfo: getBadgeInfo,
  };
};
